/* eslint-disable no-use-before-define */
import React, { useState, useCallback, useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';


import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';

import {
  Box,
  Button,
  Card,
  Drawer,
  Hidden,
  InputAdornment ,
  List,
  ListSubheader,
  Modal,
  TextField,
  Typography,
  makeStyles,
  Divider
} from '@material-ui/core';
import {
  Grid as GridIcon,
  BarChart as BarChartIcon,
  Radio as RadioIcon,
  Settings as SettingsIcon,
  Slack as SlackIcon,
} from 'react-feather';
import { 
  AiOutlineTeam,
  AiFillFileWord,
  AiOutlineOrderedList,
  AiOutlineNotification,
  AiOutlineAreaChart
 } from "react-icons/ai";
import axios from 'src/utils/axios';
import useIsMountedRef from 'src/hooks/useIsMountedRef';
import Logo from 'src/components/Logo';
import Image from 'src/components/Image';
import useAuth from 'src/hooks/useAuth';
import NavItem from './NavItem';
import FarmAddButton from 'src/components/FarmAddButton';
import useLocalStorage from 'src/hooks/useLocalStorage';
import Account from 'src/components/Account';
import { useDispatch, useSelector } from 'src/store';
import { updateFarm } from 'src/slices/farm';
import { updateFeed } from 'src/slices/feed';
import { updateMenu } from 'src/slices/menu';
import { updateWtank } from 'src/slices/wtank';
import { updateBreedinfo } from 'src/slices/breedinfo';
import { updateFeedaction } from 'src/slices/feedaction';
import { updateParameters } from 'src/slices/parameter';
import { updateNotificationlog } from 'src/slices/notificationlog';
import { updateNotification } from 'src/slices/notification';
import moment from 'moment';
import 'moment/locale/ko';

const drawerWidth = "256px";

// 스토어에 있는 selectedFarm 리듀서 상태 사용

// const farms = [
//   {
//     value: 'AD_Gochang',
//     label: 'AD GOCHANG',
//   },
//   {
//     value: 'Outside_Indonesia',
//     label: 'OUTSIDE INDONESIA',
//   },
// ];

// 모달 내부 좌표 위치
function rand() {
  return Math.round(Math.random() * 20) - 10;
  // return Math.round(Math.random() * 10) - 15;
}

function getFarmAddModalStyle() {
  const top = 50 + rand();
  // const left = 50 + rand();

  return {
    // top: `${top}%`,
    top: `calc( 50% - 325px )`,
    margin: "auto"
    // left: `${left}%`,
    // transform: `translate(-${top}%, -${left}%)`,
  };
}


const sections = [
  // {
  //   subheader: '일반',
  //   items: [
  //     {
  //       title: '대시보드',
  //       icon: SlackIcon,
  //       href: '/app/reports/dashboard/device'
  //       // href: '/app/reports/dashboard-farm'
  //     },
  //     // {
  //     //   title: 'Farm Setting',
  //     //   icon: SettingsIcon,
  //     //   href: '/app/reports/dashboard/farmsetting'
  //     // },
  //   ]
  // },

  {
    // subheader: '메뉴',
    items: [
      {
        title: '대시보드',
        icon: AiOutlineAreaChart,
        href: '/app/dashboard'
        // href: '/app/reports/dashboard-farm'
      },
      {
        title: '회원 관리',
        icon: AiOutlineTeam,
        // href: '/app/management/customer',
        items: [
          {
            title: '회원 목록',
            href: '/app/management/customers'
          },
          {
            title: '회원 등록',
            href: '/app/management/customers/0/edit'
          },
          {
            title: '회원 일괄등록',
            href: '/app/management/customers/import'
          }
        ]
      },
      {
        title: '명언 관리',
        icon: AiFillFileWord,
        // href: '/app/management/analysis',
        items: [
          {
            title: '명언 목록',
            href: '/app/management/words'
          },
          {
            title: '명언 등록',
            href: '/app/management/words/0/edit'
          },
          {
            title: '명언 일괄등록',
            href: '/app/management/words/import'
          }
        ]
      },
      {
        title: '명언발행로그 관리',
        icon: AiOutlineOrderedList,
        // href: '/app/management/notification',
        items: [
          {
            title: '명언발행로그 목록',
            href: '/app/management/publishLogs'
          },
          {
            title: '명언발행로그 등록',
            href: '/app/management/publishLogs/0/edit'
          },
          {
            title: '명언발행로그 일괄등록',
            href: '/app/management/publishLogs/import'
          }
        ]
      },
      {
        title: '알림 관리',
        icon: AiOutlineNotification,
        // href: '/app/management/notification',
        items: [
          {
            title: '스케줄 관리 ',
            href: '/app/management/pushSchedules'
          },
          {
            title: '로그 관리',
            href: '/app/management/pushLogs'
          },
          {
            title: '알림 보내기',
            href: '/app/management/pushSend'
          },
        ]
      },
      
    ]
  },
 
];



const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor:theme.palette.background.default,
    height: '100%'
  },
  mobileDrawer: {
    backgroundColor:theme.palette.background.default,
    height: '100%',
    width: 256,
  },
  desktopDrawer: {
    backgroundColor:theme.palette.background.default,
    height: '100%',
    width: 256,
    // top: 64,
    // height: 'calc(100% - 64px)'
  },
  avatarCard: {
    padding: '16px 12px 16px 12px'
    
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  },
  selectBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    borderRadius: "8px",
    // height:"70px",
    width: "234px",
    marginTop: "32px"
  },
  select: {
    borderRadius: "8px",
    margin: "auto",
    bordor: "none",
    width: "234px",
    // height: "70px",
    boxShadow: "none",
  },
  selectText: {
    fontSize: '15px',
    // color: "#FFFFFF"
    color: "rgba(24, 24, 25, 0.6)"
  },
  optionText: {
    fontSize: '14px',
    color: "rgba(24, 24, 25, 0.6)"
  },
  avatarText: {
    fontSize: '12px',
    color: "rgba(24, 24, 25, 0.6)",
    marginLeft: "8px",
    fontWeight: 400,
  },
  subheader: {
    fontFamily: "Roboto",
    fontStyle:"normal",
    fontWeight: 700,
    fontSize: "14px",
    color: "rgba(24, 24, 25, 0.6)",
    lineHeight: "16.8px",
    marginTop: "42px"
  },
  copyrightBox: {
    width: "100%",
    position: "absolute",
    botton: "16px",
    display:"flex",
    justifyContent: "center",
    // height: "calc( 100% - 625px )",
    // paddingTop: "calc( 100% - 32px)",

    // paddingTop: "calc( 100% - 200px )"
  },
  copyright: {
    fontFamily: "Roboto",
    fontStyle:"normal",
    fontWeight: 500,
    fontSize: "14px",
    color: "#B1B2B4",
    lineHeight: "19.6px",
    textAlign: "center"
  },
  formControl :{
    width: "100%",
  },
  paper: {
    position: 'absolute',
    width: 771,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: 8,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    [theme.breakpoints.down("md")]:{
      width: "100%"
    }
  },

}));

const NavBar = ({ onMobileClose, openMobile, changeMenu }) => {
  const classes = useStyles();
  const farm = useSelector((state) => state.farm.value); // store 구독
  const feed = useSelector((state) => state.feed.value); // store 구독
  const feedaction = useSelector((state) => state.feedaction.value); // store 구독
  const menu = useSelector((state) => state.menu.value); // store 구독
  const wtank = useSelector((state) => state.wtank.value); // store 구독
  const breedinfo = useSelector((state) => state.breedinfo.value); // store 구독
  const parameter = useSelector((state) => state.parameter.value); // store 구독
  const notificationlog = useSelector((state) => state.notificationlog.value); // store 구독
  const notification = useSelector((state) => state.notification.value); // store 구독

  const dispatch = useDispatch();
  // console.log("currentFarm : "+farm.selectedFarm);

  // 측정정보 인터벌 인스턴스 Id를 로컬 storage에 저장한다. 
  const [intervalIdValue, setIntervalIdValue] = useLocalStorage("intervalIdValue",0);

  // 측정정보 인터벌 인스턴스를 삭제한다.
  clearInterval(intervalIdValue); 

  const isMountedRef = useIsMountedRef();
  const location = useLocation();
  const { user } = useAuth();
  // console.log("user",user);

  // 농장 변경
  const farmChange = async (e) => {
    console.log("farmChange!", e.target.value);
    // console.log("intervalIdValue",intervalIdValue);
    // 인터벌 인스턴스를 삭제한다.
    clearInterval(intervalIdValue); 
    
    let selectedFarmName = e.target.value;

    const responseFeed = await axios.get('/api/feed/count',{params: {farmName: selectedFarmName}});
    const responseFarm = await axios.get('/api/farm/search', {params: {farmName: selectedFarmName}});
    const responseWtank = await axios.get('/api/wtank/count',{params: {farmName: selectedFarmName}});
    // const responseParameter = await axios.get('/api/parameter/count',{params: {farmName: selectedFarmName, wtank: wtank.selectedWtankItem === undefined ? 0 : wtank.selectedWtankItem['number']}});
    // const responseNotificationlog = await axios.get('/api/notificationlog/allcount',{params: {farmName: farm.selectedFarm}}); // 농장에 등록된 모든 알람로그 데이터를 가져온다.
    // const responseNotification = await axios.get('/api/notification/allcount',{params: {farmName: farm.selectedFarm}}); // 농장에 등록된 모든 알람종류 데이터를 가져온다.

    let selectedFarmItem = responseFarm.data;

    let currentFarm = {
      ...farm,
      totalWtank: responseWtank.data['count'], // 총수조 수 업데이트
      selectedFarm : selectedFarmName,
      selectedFarmItem: selectedFarmItem,
    };
    
    dispatch(updateFarm(currentFarm)); // reduce action 실행
    
    let currentWtank = {
      ...wtank,
      selectedWtank : "default",
      selectedWtankInfo:{
        number:0, // 선택된 수조번호로 초기화 한다.
        area: 0,
        length: 0,
        width: 0,
        depth: 0,
        breedinfoId: null,
        position: "",
        inputDate: "",
        individuals: 0,
        totalPeriod: 0,
        currentPeriod: 0,
      },
      estimatedInfo: {},
      estimatedInfoData: {},
      selectedWtankItem: undefined,
      // wtankData: responseWtank.data['rows'],
      wtankData: {},
    };
  
  dispatch(updateWtank(currentWtank)); // reduce action 실행

    let currentBreedinfo = {
      ...breedinfo,
      selectedBreedinfo: "default",
      selectedBreedinfoInfo:{
        id: "",
        farmName: "",
        name: "",
        position: "",
        inputDate: "",
        individuals: 0,
        shipmentTarget: "",
        totalPeriod: 0,
        currentPeriod: 0,
        },
        breedinfoData: {},
    };
    
    dispatch(updateBreedinfo(currentBreedinfo)); // reduce action 실행

    // 급이이력 store state를 업데이트 한다.
    let currentFeedaction = {
      ...feedaction,

      feedactionData: [],
    }
    dispatch(updateFeedaction(currentFeedaction));

    // 매개변수 store state를 업데이트 한다.
    let currentParameter = {
        ...parameter,
        selectedParameter: "default",
        parameterData : [],
        parameterType: []
      }
      dispatch(updateParameters(currentParameter));

    // 사료정보 store state를 업데이트 한다.
    let currentfeed = {
      ...feed,
      feedData : responseFeed.data['rows']
    }
    dispatch(updateFeed(currentfeed));

    // notificationlog(알람로그) state를 설정 한다. 
    let currentNotificationlog = {
      ...notificationlog,
      selectedNotificationlogData : {},
      currentNotificationlog : [],
      notificationlogData : []
    }

    // notificationlog(알람로그) store state를 업데이트 한다. 
    dispatch(updateNotificationlog(currentNotificationlog));

    // notification(알람목록) state를 설정 한다. 
    let currentNotification = {
      ...notification,
      currentNotification : [],
      notificationData : [],
    }

    // notification(알람목록) store state를 업데이트 한다. 
    dispatch(updateNotification(currentNotification));

    console.log("farmChange",farm);
  }

  // 메뉴 변경
  const menuChange = (e) => {
    let currentMenu = {
      ...menu,
      selectedMenu : e.target.innerHTML,
    }
    dispatch(updateMenu(currentMenu));
  }

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  var farms = [];

  const getItems = useCallback(async () => {
    try {
     
    } catch (err) {
      console.error(err);
    }
  }, [isMountedRef]);
  // }, []);

  // useEffect(() => {
  //   getItems();
  // }, [getItems]);

  function renderNavItems({
    items,
    pathname,
    depth = 0,
    changeMenu,
    // currentFarm = user.farmname
  }) {
    // console.log(items);
    return (
      <List disablePadding key={pathname} style={{color:"rgba(24, 24, 25, 0.6)"}}>
        {items.reduce(
          (acc, item) => reduceChildRoutes({ acc, item, pathname, depth, changeMenu}),
          []
        )}
      </List>
    );
  }

  // 농장 select 요소를 반환한다.
  function renderFarmSelect(farmSelectList) {
    // console.log(farmSelectList)
    
    if(farmSelectList){
      let farmSelect = [<option key="default" value="default" className={classes.optionText}>농장 선택</option>]
      farmSelect.push(
        farmSelectList.map((option) => (
          <option key={option.value} value={option.value} className={classes.optionText}>
            {option.label}
          </option>
        ))
      )
      return (
        farmSelect
      );
    }
  }

  function reduceChildRoutes({
    acc,
    item,
    pathname,
    depth,
  }) {
    const key = item.title + depth;
  
    if (item.items) {
      const open = matchPath(pathname, {
        path: item.href,
        exact: false
      });
      acc.push(
        <NavItem
          depth={depth}
          icon={item.icon}
          info={item.info}
          key={key}
          open={Boolean(open)}
          title={item.title}
          style={{color:"rgba(24, 24, 25, 0.6)",}}
          // currentFarm={user.farmname}
        >
          {renderNavItems({
            depth: depth + 1,
            pathname,
            items: item.items
          })}
        </NavItem>
      );
    } else {
      acc.push(
        <NavItem
          depth={depth}
          href={item.href}
          icon={item.icon}
          info={item.info}
          key={key}
          title={item.title}
          style={{color:"rgba(24, 24, 25, 0.6)"}}
          // currentFarm={user.farmname}
        />
      );
    }
  
    return acc;
  }



  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <PerfectScrollbar 
        className={classes.root}
        options={{ suppressScrollX: true }}
      >
        {/* <Hidden lgUp> */}
          <Box
            mt={'40px'}
            mx={1}
            display="flex"
            flexDirection={"column"}
            justifyContent="center"
            alignItems={"center"}
          >
            {/* <RouterLink 
              to="/"
              style={{textDecoration: 'none'}}
            >
              <Logo />
            </RouterLink> */}
            <Card className={classes.avatarCard}>
              <Box 
                display={"flex"}
                flexDirection="row"
                alignItems={"center"}
                pb={1}
              >
                <Account />
                <Typography className={classes.avatarText}>님이 접속하였습니다.</Typography>
              </Box>
              <Divider/>
              <Box pt={1}>
                <Typography className={classes.avatarText}>
                  * 마지막 접속시간 
                </Typography>
              </Box>
              <Box>
                <Typography className={classes.avatarText}>
                  {moment(user.lastactivity).format("YYYY-MM-DD(ddd) HH:mm:ss ")}
                </Typography>
              </Box>
            </Card>
          </Box>
        {/* </Hidden> */}
        {/* <Box 
          dispaly="flex" 
          justifyContent="center"
        >
          <Box
            className={classes.selectBox}
            mx={1}
          >
          <TextField
              className={classes.select}
              fullWidth
              id="role"
              name="role"
              margin="normal"
              select
              // label="Role"
              value={farm.selectedFarm} // 계정 정보에 있는 farmname을 기본값으로 설정한다.
              onChange={(event) => farmChange(event)}
              variant="outlined"
              SelectProps={{
                native: true,
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Box
                      display="flex"
                      alignItems="center"
                    >
                      <Image alt={'avatar'} folder={'nav'} filename={'avatar'} width={'32px'} height={'32px'} /> 
                    </Box>
                  </InputAdornment>
                ),
                className: classes.selectText // select 상자안의 text style
              }}
              // helperText="Please select your role"
            >
              {renderFarmSelect(farm.farmSelectList)}
            </TextField>
          </Box>
        </Box> */}
        {/* 농장 추가 버튼 */}
        {/* <Box mx={1} mt={"18px"}>
          <FarmAddButton />
        </Box> */}
        
        <Box pt={"8px"} pb={""} p={2}>
          {sections.map((section) => (
            <List
              // key={section.subheader}
              key={'메뉴'}
              subheader={(
                <ListSubheader
                  disableGutters
                  disableSticky
                  className={classes.subheader}
                >
                  {section.subheader}
                </ListSubheader>
              )}
            >
              {renderNavItems({
                menuChange,
                items: section.items,
                pathname: location.pathname,
                // currentfarm: user.farmname
              })}
            </List>
          ))}
        </Box>
        {/* <Divider /> */}
        {/* <Box className={classes.copyrightBox}>
          <Box >
            <Typography className={classes.copyright}>
              © SOTHECODE. All rights reserved.
            </Typography>
          </Box>
        </Box> */}
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              boxSizing: 'border-box',
            },
          }}
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          onClose={onMobileClose}
          // open={openMobile}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default NavBar;
